import React from "react";
import "./Careers.css";
import Footer from "../components/Footer";
import ImgSales from "../assets/Rectangle4.png.webp";
import ImgWarehouse from "../assets/Rectangle3.png.webp";
import ImgMarketing from "../assets/Home Lighting.png.webp";
import ImgFeature from "../assets/Industrial Lighting.png.webp";
import Avatar from "../assets/icons/avatar.png.webp";
import ImgSubtleCta from "../assets/careers-subtle-cta.png.webp";

const CAREERS_EMAIL = "chamindu@bixton.com";

const openCareersEmail = (subject?: string) => {
  const url = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(
    CAREERS_EMAIL,
  )}&su=${encodeURIComponent(subject ?? "Careers inquiry — Bixton")}`;
  window.open(url, "_blank");
};

const Careers: React.FC = () => {
  return (
    <div className="contact-us-container careers-page">
      <section className="careers-hero">
        <div className="careers-hero-inner">
          <h1>
            Human Talent at{" "}
            <span className="careers-brand">Bixton</span>
          </h1>
          <p className="careers-lead">
            At <span className="careers-brand">Bixton</span>, we are dedicated
            to attracting and retaining top talent. Every team member&apos;s
            skills are regularly assessed, with training and mentorship provided
            to help them grow. We support further education and professional
            development, including sponsorships where needed.
          </p>
        </div>
      </section>

      <div className="careers-strip">
        <p>
          Quarterly training sessions, guided by both internal and external
          faculty, ensure our team stays sharp. External consultants also assess
          skills to help each individual reach their full potential.
        </p>
        <p>
          We provide opportunities for self-development and motivation,
          nurturing young professionals with passion and potential through
          guidance, mentoring, and continuous learning.
        </p>
        <p className="careers-vacancies-line">
          To explore current vacancies, please{" "}
          <a className="careers-vacancies-link" href="#careers-openings">
            click here
          </a>
          .
        </p>
        <p className="careers-vacancies-line careers-applications-email">
          Send applications and CVs to{" "}
          <a
            href={`mailto:${CAREERS_EMAIL}`}
            className="careers-vacancies-link"
          >
            {CAREERS_EMAIL}
          </a>
          .
        </p>
      </div>

      <section
        className="careers-mosaic"
        id="careers-openings"
        aria-label="Careers highlights"
      >
        <div className="careers-mosaic-inner">
          <div className="careers-grid">
            {/* Row 1 — three image cards */}
            <article className="careers-card careers-span-4">
              <div className="careers-card-media">
                <img loading="lazy" decoding="async" src={ImgSales} alt="" />
              </div>
              <div className="careers-card-body">
                <div className="careers-card-meta">
                  <img loading="lazy" decoding="async"
                    className="careers-card-avatar"
                    src={Avatar}
                    alt=""
                    width={28}
                    height={28}
                  />
                  <span className="careers-card-by">Bixton HR</span>
                  <span className="careers-card-sep">·</span>
                  <span className="careers-card-read">2 min read</span>
                </div>
                <h3 className="careers-card-title">
                  Sales &amp; key accounts
                </h3>
                <p className="careers-card-excerpt">
                  Grow relationships with retailers, projects, and partners.
                  Strong communication and a customer-first attitude are
                  essential.
                </p>
                <div className="careers-card-actions">
                  <button
                    type="button"
                    className="careers-link-btn"
                    onClick={() =>
                      openCareersEmail("Application — Sales & key accounts")
                    }
                  >
                    Apply now →
                  </button>
                </div>
              </div>
            </article>

            <article className="careers-card careers-span-4">
              <div className="careers-card-media">
                <img loading="lazy" decoding="async" src={ImgWarehouse} alt="" />
              </div>
              <div className="careers-card-body">
                <div className="careers-card-meta">
                  <img loading="lazy" decoding="async"
                    className="careers-card-avatar"
                    src={Avatar}
                    alt=""
                    width={28}
                    height={28}
                  />
                  <span className="careers-card-by">Bixton HR</span>
                  <span className="careers-card-sep">·</span>
                  <span className="careers-card-read">2 min read</span>
                </div>
                <h3 className="careers-card-title">
                  Warehouse &amp; logistics
                </h3>
                <p className="careers-card-excerpt">
                  Support inbound, storage, and dispatch in a busy facility.
                  Detail and teamwork in a fast-paced environment.
                </p>
                <div className="careers-card-actions">
                  <button
                    type="button"
                    className="careers-link-btn"
                    onClick={() =>
                      openCareersEmail(
                        "Application — Warehouse & logistics",
                      )
                    }
                  >
                    Apply now →
                  </button>
                </div>
              </div>
            </article>

            <article className="careers-card careers-span-4">
              <div className="careers-card-media">
                <img loading="lazy" decoding="async" src={ImgMarketing} alt="" />
              </div>
              <div className="careers-card-body">
                <div className="careers-card-meta">
                  <img loading="lazy" decoding="async"
                    className="careers-card-avatar"
                    src={Avatar}
                    alt=""
                    width={28}
                    height={28}
                  />
                  <span className="careers-card-by">Bixton HR</span>
                  <span className="careers-card-sep">·</span>
                  <span className="careers-card-read">3 min read</span>
                </div>
                <h2 className="careers-card-title">
                  Marketing &amp; content
                </h2>
                <p className="careers-card-excerpt">
                  Tell the Bixton story across digital and print. Campaigns,
                  social, and brand assets experience is a plus.
                </p>
                <div className="careers-card-actions">
                  <button
                    type="button"
                    className="careers-link-btn"
                    onClick={() =>
                      openCareersEmail("Application — Marketing & content")
                    }
                  >
                    Apply now →
                  </button>
                </div>
              </div>
            </article>

            {/* Row 2 — feature + compact */}
            <article className="careers-card careers-feature careers-span-8">
              <div className="careers-card-media careers-card-media--tall">
                <img loading="lazy" decoding="async" src={ImgFeature} alt="" />
              </div>
              <div className="careers-card-body">
                <div className="careers-card-meta">
                  <img loading="lazy" decoding="async"
                    className="careers-card-avatar"
                    src={Avatar}
                    alt=""
                    width={28}
                    height={28}
                  />
                  <span className="careers-card-by">Bixton Team</span>
                  <span className="careers-card-sep">·</span>
                  <span className="careers-card-read">4 min read</span>
                </div>
                <h3 className="careers-card-title">
                  Life at our Colombo hub
                </h3>
                <p className="careers-card-excerpt">
                  Our warehouse and office work together with clear processes
                  and modern tools so you can focus on doing great work—not
                  fighting friction. We hire for attitude and train for skill.
                </p>
                <div className="careers-card-actions">
                  <button
                    type="button"
                    className="careers-link-btn"
                    onClick={() => openCareersEmail("General inquiry — Careers")}
                  >
                    Learn more →
                  </button>
                </div>
              </div>
            </article>

            <article
              className="careers-card careers-card--text-only careers-card--subtle-accent careers-span-4"
              aria-labelledby="careers-dont-see-role-title"
            >
              <div className="careers-card-subtle-visual" aria-hidden="true">
                <img loading="lazy" decoding="async" src={ImgFeature} alt="" />
              </div>
              <div className="careers-card-body">
                <div className="careers-card-meta">
                  <img loading="lazy" decoding="async"
                    className="careers-card-avatar"
                    src={Avatar}
                    alt=""
                    width={28}
                    height={28}
                  />
                  <span className="careers-card-by">Bixton HR</span>
                  <span className="careers-card-sep">·</span>
                  <span className="careers-card-read">1 min read</span>
                </div>
                <h3
                  id="careers-dont-see-role-title"
                  className="careers-card-title"
                >
                  Don&apos;t see your role?
                </h3>
                <p className="careers-card-excerpt">
                  Send your CV and a short note on what you bring. We keep strong
                  profiles on file and reach out when a fit opens up.
                </p>
                <div className="careers-card-actions">
                  <button
                    type="button"
                    className="careers-link-btn"
                    onClick={() =>
                      openCareersEmail("General application — CV attached")
                    }
                  >
                    Send your CV →
                  </button>
                </div>
              </div>
            </article>

            {/* Row 3 — three text-only */}
            <article className="careers-card careers-card--text-only careers-span-4">
              <div className="careers-card-body">
                <div className="careers-card-meta">
                  <img loading="lazy" decoding="async"
                    className="careers-card-avatar"
                    src={Avatar}
                    alt=""
                    width={28}
                    height={28}
                  />
                  <span className="careers-card-by">Culture</span>
                  <span className="careers-card-sep">·</span>
                  <span className="careers-card-read">1 min read</span>
                </div>
                <h3 className="careers-card-title">Integrity first</h3>
                <p className="careers-card-excerpt">
                  We source from reputable partners and stand behind compliance
                  and quality—the same bar applies to how we treat each other.
                </p>
              </div>
            </article>

            <article className="careers-card careers-card--text-only careers-span-4">
              <div className="careers-card-body">
                <div className="careers-card-meta">
                  <img loading="lazy" decoding="async"
                    className="careers-card-avatar"
                    src={Avatar}
                    alt=""
                    width={28}
                    height={28}
                  />
                  <span className="careers-card-by">Culture</span>
                  <span className="careers-card-sep">·</span>
                  <span className="careers-card-read">1 min read</span>
                </div>
                <h3 className="careers-card-title">Keep learning</h3>
                <p className="careers-card-excerpt">
                  Lighting and regulations evolve. We encourage curiosity and
                  sharing what you learn so the whole team levels up.
                </p>
              </div>
            </article>

            <article className="careers-card careers-card--text-only careers-span-4">
              <div className="careers-card-body">
                <div className="careers-card-meta">
                  <img loading="lazy" decoding="async"
                    className="careers-card-avatar"
                    src={Avatar}
                    alt=""
                    width={28}
                    height={28}
                  />
                  <span className="careers-card-by">Culture</span>
                  <span className="careers-card-sep">·</span>
                  <span className="careers-card-read">1 min read</span>
                </div>
                <h3 className="careers-card-title">Service mindset</h3>
                <p className="careers-card-excerpt">
                  Whether you face internal colleagues or external customers,
                  we expect respect, clarity, and follow-through.
                </p>
              </div>
            </article>
          </div>
        </div>
      </section>

      <section className="careers-cta-band" aria-label="Call to action">
        <div className="careers-cta-inner">
          <h2>
            Illuminate your future with{" "}
            <span className="careers-cta-domain">Bixton.lk</span>
          </h2>
          <button
            type="button"
            className="careers-cta-btn"
            onClick={() => openCareersEmail()}
          >
            Get in touch
          </button>
        </div>
      </section>

      <section style={{ marginTop: "80px" }}>
        <Footer />
      </section>
    </div>
  );
};

export default Careers;
